import { render, staticRenderFns } from "./ModalDataMonitor.vue?vue&type=template&id=af5d2c22&scoped=true"
import script from "./ModalDataMonitor.vue?vue&type=script&lang=js"
export * from "./ModalDataMonitor.vue?vue&type=script&lang=js"
import style0 from "./ModalDataMonitor.vue?vue&type=style&index=0&id=af5d2c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5d2c22",
  null
  
)

export default component.exports